import { useTranslation } from "react-i18next";
import { useThreadContext } from "../threadPageContext";
import { showCurrentStep } from "./currentStepElement";

/** What the link asks of the reader at the current step: to look at what it shows, or to answer it. */
export type CurrentStepLinkPurpose = "look" | "answer";

/**
 * The log's link to the current step, which shows what the log points at once (F104). It says where it leads, down
 * the page (F164), and the jump lands focus on the step.
 */
export default function CurrentStepLink({ purpose }: { purpose: CurrentStepLinkPurpose }) {
  const { t } = useTranslation();
  const { currentStep } = useThreadContext();
  return (
    <button type="button" className="app-link app-link-cue-down text-xs underline" onClick={() => { showCurrentStep(currentStep); }}>
      {t(purpose === "answer" ? "threads.current.answerThere" : "threads.current.goTo")}
    </button>
  );
}
